import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// import AddButton from '../../../components/common/AddButton/AddButton';
import Filter from '../../components/common/Filter/Filter';
import Sort from '../../components/common/Sort/Sort';
import ExportLabel from '../../components/common/ExportLabel/Export';
import PageHeader from '../../components/common/PageHeader/PageHeader';
import SimpleSearchBox from '../../components/common/Search/SimpleSearch';
import ArchiveSelectedItem from '../../components/common/ArchiveSelectedItemLabel/ArchiveSelectedItems';

import authenticatedAxios from '../../authenticatedAxios';
import { baseurl } from '../../api';
import { useCheckboxClick } from '../../checkboxclick';
import useFilterStore from '../../store/useFilterStore';
import useRefreshStore from '../../store/useRefreshStore';
import ApprovalButton from '../../components/common/ApprovalButton/ApprovalButton';
import {
  getPlanExtensions,
  approvePlanExtension,
  rejectPlanExtension
} from "../../services/FreeTrial/FreeTrail";


const pageKey = "plan_approvals";

const PlanApprovals = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    fetchPlanExtensions();
  }, []);

  const fetchPlanExtensions = async () => {
    try {
      setLoading(true);
      const data = await getPlanExtensions(); // API call
      setItems(data);
    } catch (error) {
      console.error("Error fetching plan extensions:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleApprove = async (id) => {
    try {
      await approvePlanExtension(id);  // no dates
      fetchPlanExtensions();
    } catch (error) {
      console.error("Approve failed:", error);
    }
  };

  const handleReject = async (id) => {
    try {
      await rejectPlanExtension(id);
      fetchPlanExtensions(); // refresh
    } catch (error) {
      console.error("Reject failed:", error);
    }
  };


  // ─── Render ───────────────────────────────────────────────────────────────────

  return (
    <div className="whole-container">

      <div className="top-heading">
        <PageHeader pageName="Free Trial /" nestedpageName="Free Trial Users" linkTo="" />
        <div className="export-container">
          {/* <ArchiveSelectedItem
           selectedItems={selectedItems} /> */}
          {/* <ExportLabel/> */}
        </div>
      </div>

      <div className="pagename-container">
        <div className="page-name">
          <h1 className="common-text fts-22 ftw-6 blue">Free Trial Users</h1>
        </div>
        <div className="pagename-right-container">
          {/* <AddButton onClick={handleNewClick} /> */}
          {/* <SimpleSearchBox
            placeholder="Search Free Trial Users"
            onSearchSelect={handleSearchSelect}
            defaultValue={searchParams?.term}
          /> */}
          {/* <Filter
            options={filterOptions}
            onFilterSelect={handleFilterSelect}
            defaultValue={selectedFilterOption}
          /> */}
          <Sort/>
        </div>
      </div>

      <div className="table-container">
        <table className="common-table">
          <thead className="common-table-head">
            <tr className="common-table-thead-tr">
              <th className="d-flex ai-center">
                 <input
                    className="table-selectbox table-parent-selectbox"
                    type="checkbox"
                  />
                COMPANY Name
              </th>
              <th>Request date</th>
              <th>USER ACCOUNTS</th>
              <th>TRIAL PERIOD</th>
              <th>LOCATION</th>
              <th>Request Count</th>
              <th></th>
            </tr>
          </thead>

          <tbody className="common-table-tbody">
            {items.length === 0 ? (
              <tr>
                <td colSpan="7">No data found</td>
              </tr>
            ) : (
              items.map((item) => (
                <tr key={item.id}>
                  <td className="ai-center">
                    <input type="checkbox" />
                    {item.company_name}
                  </td>

                  <td>
                    {new Date(item.created_datetime).toLocaleDateString()}
                  </td>

                  <td>{item.user_accounts_snapshot}</td>

                  <td>
                    {item.start_date && item.end_date ? (
                      <span>
                        {new Date(item.start_date).toLocaleDateString()} 
                        {" TO "}
                        {new Date(item.end_date).toLocaleDateString()}
                      </span>
                    ) : item.status === "pending" ? (
                      <span style={{ color: "#888", fontStyle: "italic" }}>
                        {item.trial_period_days ? `${item.trial_period_days} days (pending)` : "Pending"}
                      </span>
                    ) : (
                      <span>—</span>
                    )}
                  </td>

                  <td>{item.location}</td> {/* optional: location */}

                  <td>{item.request_sequence}</td>

                  <td>
                    <ApprovalButton
                      status={item.status}
                      onApprove={() => handleApprove(item.id)}
                      onReject={() => handleReject(item.id)}
                    />
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      
    </div>
  );
};

export default PlanApprovals;